import {
  extend,
  localize, ValidationObserver,
  ValidationProvider
} from "vee-validate";
import en from "vee-validate/dist/locale/en.json";
import * as rules from "vee-validate/dist/rules";
import Vue from 'vue';

extend('regex_password', {
  validate: value => {
    const passwordRegex = new RegExp(/(?=.*[a-z])(?=.*[0-9])(?=.*[ -/:-@\[-`{-~]).{8,64}/)
    const emailRegex = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
    return passwordRegex.test(value) && !emailRegex.test(value);
  }
});

extend('blackListEmail', {
  validate: value => {
      const domainBlacklist = ['tivoli-hotels.com','events.anantara-hotels.com','external.nh-hotels.com','pre.nh-hotels.com','nhhotelgroup.onmicrosoft.com','nh-hotels.com','nhhotelgroup.mail.onmicrosoft.com','nhow-hotels.com','coperama.com','nh-hotels.co.za','anantarahotels.com','hotelstivoli.com','nh-hoteles.com','nh-hoteles.es','anantara.pt','minorhotels.pt','avanihotels.pt','anantara-hotels.com','avani-hotels.com','hotelcarloivprague.com','dahotels.com','themarker.ie','minor-hotels.com']
      const match = value.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      return !(match !== null && domainBlacklist.includes(match[5]))
  }
});

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

localize("en", en);

// Install VeeValidate components globally
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
